import { render, staticRenderFns } from "./addProtocol.vue?vue&type=template&id=29cbfded&scoped=true"
import script from "./addProtocol.vue?vue&type=script&lang=js"
export * from "./addProtocol.vue?vue&type=script&lang=js"
import style0 from "./addProtocol.vue?vue&type=style&index=0&id=29cbfded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cbfded",
  null
  
)

export default component.exports